import type { ReactNode } from 'react';
import { cn } from '../../lib/utils.ts';
import { countPill, RAIL_ROWS } from '../ui/urgency-rail.ts';

/**
 * One group of a task page (Overdue, This week…): a card whose first row is drawn like a record
 * table's header row, so its label lines up with the rows under it as a list's columns do.
 * Overdue's label is red and its rows carry the red urgency rail (`urgency-rail.ts`).
 */
export function TaskGroup({
  name,
  count,
  children,
}: {
  name: string;
  count: number;
  children: ReactNode;
}) {
  const overdue = name === 'Overdue';
  return (
    <section
      data-testid={`task-group-${name}`}
      className="bg-card border-border rounded-card shadow-card overflow-hidden border"
    >
      <h3
        className={cn(
          'bg-muted flex items-center gap-1.5 px-4 py-3 text-xs font-semibold shadow-[inset_0_-1px_0_var(--color-border)]',
          overdue ? 'text-danger' : 'text-muted-foreground',
        )}
      >
        {name}
        <span className={cn(countPill, 'bg-card')}>{count}</span>
      </h3>
      <ul className={cn('divide-border divide-y', overdue && RAIL_ROWS.danger)}>{children}</ul>
    </section>
  );
}
